@if (props.actionButtons) {
  <div class="formly-button-actions">
    @if (!formControl?.value?.is_edit) {
      <cap-button
        styleClass="default primary round btn-sm icon-only"
        icon="mynaui-pencil"
        [disabled]="formControl?.value?.is_edit"
        (onClick)="edit()" />

      @if (props.deletable) {
        <cap-button
          styleClass="default primary round btn-sm icon-only"
          icon="mynaui-trash"
          [disabled]="formControl?.value?.is_edit"
          (onClick)="remove()" />
      }
    } @else {
      <cap-button styleClass="default secondary round btn-sm icon-only" icon="mynaui-x" (onClick)="cancel()" />

      <cap-button styleClass="default secondary round btn-sm icon-only" icon="mynaui-check" (onClick)="save()" />
    }
  </div>
} @else {
  <cap-button
    [disabled]="props.disabled"
    [styleClass]="props.styleClass"
    [icon]="props.icon"
    [label]="props.translateLabel"
    (onClick)="props.onClick?.(field, formControl)" />
}
